import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employees: [],
  roles: [],
  loading: false,
  rolesLoading: false,
  error: null,
  assigningRole: false,
};

const employeeRoleSlice = createSlice({
  name: "employeeRole",
  initialState,
  reducers: {
    getEmployeeRolesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getEmployeeRolesSuccess: (state, action) => {
      state.loading = false;
      state.employees = action.payload;
    },
    getEmployeeRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getRolesForAssignmentStart: (state) => {
      state.rolesLoading = true;
      state.error = null;
    },
    getRolesForAssignmentSuccess: (state, action) => {
      state.rolesLoading = false;
      state.roles = action.payload;
    },
    getRolesForAssignmentFailure: (state, action) => {
      state.rolesLoading = false;
      state.error = action.payload;
    },
    assignRoleEmployeeStart: (state) => {
      state.assigningRole = true;
      state.error = null;
    },
    assignRoleEmployeeSuccess: (state) => {
      state.assigningRole = false;
    },
    assignRoleEmployeeFailure: (state, action) => {
      state.assigningRole = false;
      state.error = action.payload;
    },
  },
});

export const {
  getEmployeeRolesStart,
  getEmployeeRolesSuccess,
  getEmployeeRolesFailure,
  getRolesForAssignmentStart,
  getRolesForAssignmentSuccess,
  getRolesForAssignmentFailure,
  assignRoleEmployeeStart,
  assignRoleEmployeeSuccess,
  assignRoleEmployeeFailure,
} = employeeRoleSlice.actions;

export default employeeRoleSlice.reducer;
